export default __webpack_public_path__ + "static/media/ufc_logo_2.841bff1f.jpg";